function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapReact from 'google-map-react';
import supercluster from 'points-cluster';
import defaultPropTypes from '../utils/prop-types';
import FilterList from './filter-list';
import Location from '../utils/model';
import { UserLocationMarker, SearchLocationMarker, GoogleClusterMarker, GoogleMapMarker } from './google-map-markers';

var GoogleMap = /*#__PURE__*/function (_React$Component) {
  _inherits(GoogleMap, _React$Component);

  var _super = _createSuper(GoogleMap);

  function GoogleMap(props) {
    var _this;

    _classCallCheck(this, GoogleMap);

    _this = _super.call(this, props);
    _this.mapIsReset = false;
    _this.isNewSelectedLocation = false;
    _this.handleMapChange = _this.handleMapChange.bind(_assertThisInitialized(_this));
    _this.handleClusterClick = _this.handleClusterClick.bind(_assertThisInitialized(_this));
    _this.handleLocationMarkerViewClick = _this.handleLocationMarkerViewClick.bind(_assertThisInitialized(_this));
    _this.options = {
      styles: _this.getStylesFromSettings(),
      fullscreenControl: false,
      clickableIcons: false
    };
    _this.searchLocation = props.searchLocation;
    _this.userLocation = props.userLocation;
    _this.selectedLocation = props.selectedLocation;
    _this.state = {
      center: {
        lat: props.searchLocation.lat,
        lng: props.searchLocation.lng
      },
      zoom: props.settings.ZoomLevel
    };
    return _this;
  }

  _createClass(GoogleMap, [{
    key: "getStylesFromSettings",
    value: function getStylesFromSettings() {
      try {
        var cleanedString = this.props.settings.MapConfiguration.replace(/\\r/g, '').replace(/\\t/g, '').replace(/\\n/g, '').replace(/\\/g, '');
        var mapConfiguration = JSON.parse(cleanedString);
        return mapConfiguration.googlemap;
      } catch (e) {
        console.error(e);
      }

      return {};
    }
  }, {
    key: "getClusters",
    value: function getClusters(locations, center, zoom, bounds) {
      if (!this.props.useClustering) {
        return locations.map(function (location) {
          return {
            lat: location.lat,
            lng: location.lng,
            numPoints: 1,
            id: "1_".concat(location.UniqueId),
            points: [location]
          };
        });
      }

      bounds.ne.lng = 180;
      bounds.nw.lng = -180;
      bounds.se.lng = 180;
      bounds.sw.lng = -180;
      var clusters = supercluster(locations, {
        minZoom: this.props.settings.MinZoom,
        maxZoom: this.props.settings.MaxZoomLevel,
        radius: this.props.settings.ClusterRadius
      });
      var modClusters = clusters({
        bounds: bounds,
        zoom: zoom
      });
      return modClusters.map(function (_ref) {
        var wx = _ref.wx,
            wy = _ref.wy,
            numPoints = _ref.numPoints,
            points = _ref.points;
        return {
          lat: wy,
          lng: wx,
          numPoints: numPoints,
          id: "".concat(numPoints, "_").concat(points[0].UniqueId),
          points: points
        };
      });
    }
  }, {
    key: "handleMapChange",
    value: function handleMapChange(_ref2) {
      var center = _ref2.center,
          zoom = _ref2.zoom,
          bounds = _ref2.bounds;
      this.props.onMapChange({
        center: center,
        zoom: zoom,
        bounds: bounds
      });
      this.setState({
        center: center,
        zoom: zoom,
        bounds: bounds
      });
    }
  }, {
    key: "handleClusterClick",
    value: function handleClusterClick(item, currentZoom) {
      if (currentZoom < this.props.settings.MaxZoomLevel) {
        var zoom = Math.min(this.props.settings.MaxZoomLevel, currentZoom + 2);
        var center = {
          lat: item.lat,
          lng: item.lng
        };
        this.setState({
          zoom: zoom,
          center: center
        });
      }
    }
  }, {
    key: "handleLocationMarkerViewClick",
    value: function handleLocationMarkerViewClick(locationObj) {
      var _this2 = this;

      this.props.onCloseLocation();
      setTimeout(function () {
        _this2.props.onSelectLocation(locationObj);
      }, 0);
      window.DGS.Event.getInstance().trigger('trackLocationsHighlightFromMap', locationObj.Name, locationObj.PostalCode);
    }
  }, {
    key: "findSelectedLocationInClusters",
    value: function findSelectedLocationInClusters(clusters, selectedLocation) {
      var selectedClusterLocation = null;
      clusters.forEach(function (cluster) {
        cluster.points.forEach(function (clusterPoint) {
          if (clusterPoint.UniqueId === selectedLocation.UniqueId) {
            selectedClusterLocation = cluster;
          }
        });
      });
      return selectedClusterLocation;
    }
  }, {
    key: "resetMapToLocation",
    value: function resetMapToLocation(location) {
      var center = {
        lat: location.lat,
        lng: location.lng
      };
      var zoom = this.props.settings.ZoomLevel;
      var bounds = null;
      this.mapIsReset = true;
      return {
        center: center,
        zoom: zoom,
        bounds: bounds
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          center = _this$state.center,
          zoom = _this$state.zoom,
          bounds = _this$state.bounds;

      if (this.searchLocation !== this.props.searchLocation) {
        this.searchLocation = this.props.searchLocation;

        var _this$resetMapToLocat = this.resetMapToLocation(this.props.searchLocation);

        center = _this$resetMapToLocat.center;
        zoom = _this$resetMapToLocat.zoom;
        bounds = _this$resetMapToLocat.bounds;
      }

      if (this.userLocation !== this.props.userLocation) {
        this.userLocation = this.props.userLocation;

        var _this$resetMapToLocat2 = this.resetMapToLocation(this.props.userLocation);

        center = _this$resetMapToLocat2.center;
        zoom = _this$resetMapToLocat2.zoom;
        bounds = _this$resetMapToLocat2.bounds;
      }

      if (this.selectedLocation !== this.props.selectedLocation) {
        this.selectedLocation = this.props.selectedLocation;
        this.isNewSelectedLocation = true;
      } // CLUSTERING


      var clusters = bounds ? this.getClusters(this.props.locations, center, zoom, bounds) : []; // Handle if a new locations has just been clicked
      // Make sure the selected locations is visible on the map, otherwise trigger a search to
      // the selected locations latitude and longitude.

      if (clusters.length && this.isNewSelectedLocation && !this.props.selectedLocation.isDefault()) {
        var selectedLocationCluster = this.findSelectedLocationInClusters(clusters, this.props.selectedLocation);

        if (selectedLocationCluster === null) {
          // Selected location is no visible on map, trigger a new search based on the selected location lat/lng
          setTimeout(function () {
            _this3.props.onSearchLocation(_this3.props.selectedLocation);
          }, 0); // trigger search after render has finished to not create infinite loop
        }

        this.isNewSelectedLocation = false;
      } // Handle if the map has been reset either by search or new user location
      // Make sure that a minimum number of locations are shown, otherwise zoom out by one.


      if (bounds && this.mapIsReset) {
        if (clusters.length < this.props.settings.MinLocationsOnLoad && zoom > 1) {
          zoom -= 1;
        } else {
          this.mapIsReset = false;
        }
      }

      var UserLocationMarkerView = this.props.userLocationMarker;
      var ClusterMarkerView = this.props.clusterMarker;
      var LocationMarkerView = this.props.locationMarker;
      var SearchMarkerView = this.props.searchMarker;
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-map ".concat(this.props.layoutType)
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, this.props.header), /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, /*#__PURE__*/React.createElement(GoogleMapReact, {
        bootstrapURLKeys: {
          key: this.props.settings.ApiKey
        },
        zoom: zoom,
        center: center,
        options: this.options,
        onChange: this.handleMapChange
      }, /*#__PURE__*/React.createElement(UserLocationMarkerView, _extends({}, this.props.userLocation, {
        lat: this.props.userLocation.lat,
        lng: this.props.userLocation.lng
      })), /*#__PURE__*/React.createElement(SearchMarkerView, _extends({}, this.props.searchLocation, {
        lat: this.props.searchLocation.lat,
        lng: this.props.searchLocation.lng
      })), clusters.map(function (item) {
        if (item.numPoints === 1) {
          return /*#__PURE__*/React.createElement(LocationMarkerView, {
            lat: item.lat,
            lng: item.lng,
            name: item.points[0].Name,
            key: item.id,
            location: Location.fromObject(item.points[0]),
            onClick: function onClick() {
              return _this3.handleLocationMarkerViewClick(item.points[0]);
            },
            onTempSelectLocation: _this3.props.onTempSelectLocation,
            selectedClass: item.points[0].UniqueId === _this3.props.selectedLocation.UniqueId || item.points[0].UniqueId === _this3.props.tempSelectedLocation.UniqueId ? 'selected' : ''
          });
        }

        return /*#__PURE__*/React.createElement(ClusterMarkerView, {
          key: item.id,
          lat: item.lat,
          lng: item.lng,
          points: item.points,
          onClick: function onClick() {
            return _this3.handleClusterClick(item, zoom);
          }
        });
      }))), /*#__PURE__*/React.createElement(FilterList, this.props), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, this.props.footer));
    }
  }]);

  return GoogleMap;
}(React.Component);

export default GoogleMap;
GoogleMap.propTypes = {
  settings: defaultPropTypes.settings,
  locations: defaultPropTypes.locations,
  selectedLocation: defaultPropTypes.location,
  tempSelectedLocation: defaultPropTypes.location,
  openLocation: defaultPropTypes.location,
  onSelectLocation: defaultPropTypes.func,
  onCloseLocation: defaultPropTypes.func,
  onSearchLocation: defaultPropTypes.func,
  onTempSelectLocation: defaultPropTypes.func,
  header: defaultPropTypes.components,
  footer: defaultPropTypes.components,
  layoutType: defaultPropTypes.layoutType,
  searchLocation: defaultPropTypes.location,
  userLocation: defaultPropTypes.location,
  zoom: PropTypes.number,
  userLocationMarker: PropTypes.func,
  clusterMarker: PropTypes.func,
  locationMarker: PropTypes.func,
  searchMarker: PropTypes.func,
  onMapChange: PropTypes.func,
  useClustering: PropTypes.bool
};
GoogleMap.defaultProps = {
  settings: defaultPropTypes.defaultSettings,
  locations: defaultPropTypes.defaultLocations,
  selectedLocation: defaultPropTypes.defaultLocation(),
  tempSelectedLocation: defaultPropTypes.defaultLocation(),
  openLocation: defaultPropTypes.defaultLocation(),
  onSelectLocation: defaultPropTypes.defaultOnSelectLocation,
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation,
  onSearchLocation: defaultPropTypes.defaultOnSearchLocation,
  onTempSelectLocation: defaultPropTypes.defFunc,
  header: defaultPropTypes.defaultComponents(),
  footer: defaultPropTypes.defaultComponents(),
  searchLocation: defaultPropTypes.defaultSearchLocation,
  userLocation: defaultPropTypes.defaultLocation(),
  zoom: 8,
  layoutType: defaultPropTypes.defaultLayoutType,
  userLocationMarker: UserLocationMarker,
  clusterMarker: GoogleClusterMarker,
  locationMarker: GoogleMapMarker,
  searchMarker: SearchLocationMarker,
  onMapChange: function onMapChange() {},
  useClustering: true
};